import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Plane = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="plane icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2701 0.297961C21.2898 -0.0777234 22.5387 -0.220831 23.3798 0.620241C24.2209 1.46131 24.0778 2.71022 23.7021 3.72993C23.3134 4.78493 22.6 5.82705 21.9331 6.49392C21.025 7.40208 19.7623 8.61081 18.3361 9.95479L21.0341 21.9436C21.0773 22.1357 21.0038 22.3353 20.8463 22.4534L19.193 23.6934C19.0779 23.7796 18.9313 23.8122 18.7906 23.7828C18.6499 23.7533 18.5286 23.6647 18.4578 23.5396L13.3849 14.5725C12.8014 15.1133 12.2231 15.6488 11.6595 16.1706C10.5982 17.1533 9.58925 18.0875 8.69672 18.9178L9.46126 22.3582C9.49835 22.5251 9.4476 22.6994 9.32672 22.8203L8.29341 23.8536C8.19285 23.9541 8.05421 24.0071 7.91221 23.9993C7.7702 23.9914 7.63827 23.9234 7.54942 23.8124L4.27753 19.7225L0.187653 16.4506C0.076597 16.3618 0.00863101 16.2298 0.000766086 16.0878C-0.00709884 15.9458 0.0458817 15.8072 0.146448 15.7066L1.17976 14.6733C1.30064 14.5524 1.4749 14.5017 1.64178 14.5388L5.08263 15.3034C6.07516 14.2389 7.19017 13.0351 8.34808 11.7851C8.70539 11.3993 9.06677 11.0092 9.42991 10.6174L0.460435 5.54222C0.335294 5.47141 0.246692 5.35015 0.217255 5.20942C0.187817 5.06868 0.220393 4.92208 0.306664 4.80705L1.54664 3.15375C1.66478 2.99623 1.86435 2.92271 2.05644 2.96595L14.046 5.66479C15.3865 4.24112 16.5918 2.98116 17.5061 2.06688C18.173 1.40002 19.2151 0.686646 20.2701 0.297961Z"
    />
  </svg>
)
